import React from 'react'
import PropTypes from 'prop-types'
import StickyHeader from 'components/StickyHeader'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { MAIN_CONTENT, FOOTER } from 'constant'

const OneColumnBrandPage = ({ placeholders: { footer, header, mainBrandContent }}) =>
  <div>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader />
    </StickyHeaderWrapper>
    <main id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding>
      { mainBrandContent }
    </main>
    <div id={ FOOTER }>
      { footer }
    </div>
  </div>

OneColumnBrandPage.propTypes = {
  placeholders: PropTypes.shape({
    footer: PropTypes.array,
    header: PropTypes.array,
    mainBrandContent: PropTypes.array
  })
}

OneColumnBrandPage.type = 'OneColumnBrandPage'
OneColumnBrandPage.placeholders = ['footer', 'header', 'mainBrandContent']

export default OneColumnBrandPage
